import ParseHtmlClient from '@/lib/utils/parse-html-client'

export default function ParseHtml({ html }: { html: string }): JSX.Element | null {
  if (!html) {
    return null
  }

  // Check if the HTML string contains script tags
  const requiresParse = html && html.includes('<script')

  if (!requiresParse) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />
  }

  return <ParseHtmlClient html={html} />
}
